module.exports = __webpack_public_path__ + "static/cloud-7ed9ec0de6fce13a639ebc5c666b7bff.webp";